import { useMemo, useState, useEffect } from 'react';
import { ADD_OR_UPDATE_RELATIONSHIP_IN_PERSON } from '../Mutations/AddOrUpdateRelationshipInPerson'
import { useStyles } from '../Styles/styles'
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { useMutation } from '@apollo/client';
import { shouldBeLocked } from '../utils/Roles';
import { localGetData } from '../utils/utils';

//This will do it's own updates
const RelationshipDropDown = ({ startingValue = "", userRoles, userId, disabled, canEdit, targetId, relationshipId }) => {
  const classes = useStyles();
  const memoizedLocked = useMemo(() => shouldBeLocked(disabled, canEdit, userRoles), [disabled, canEdit, userRoles]);
  const [value, setValue] = useState(startingValue)

  const localSetup = localGetData(`setup`) || {}
  const { setupLists } = localSetup || {}
  const relationshipTypes = setupLists?.relationshipTypes || []

  const [addOrUpdateRelationshipInPerson] = useMutation(ADD_OR_UPDATE_RELATIONSHIP_IN_PERSON, {
    context: { serializationKey: "incidentQueue" },
  })
  
  useEffect(() => {
    if (!!value?.id && (value?.id !== startingValue?.id)) {
      addOrUpdateRelationshipInPerson({ variables: { input: { originatorId: userId, targetId: targetId, relationshipId: relationshipId, relationshipTypeId: value?.id } } })
    }
  }, [value, startingValue, addOrUpdateRelationshipInPerson, userId, targetId, relationshipId])

  return (
    <FormControl variant="standard" className={classes.textfieldMarginAndFlexEnd}>
      <InputLabel shrink={true} className={classes.label} data-cy={"Relationship-type-label"} id={"Relationship-type-label"}>
        Relationship&nbsp;Type
      </InputLabel>
      <Select
        disabled={memoizedLocked}
        inputProps={memoizedLocked ? { className: classes.disabled } : {}}
        data-cy={"Relationship-type-select"}
        labelId={"Relationship-type-label"}
        id={"Relationship-type-id"}
        // defaultValue={startingValue}
        value={!value || relationshipTypes?.length === 0 ? "" : relationshipTypes[relationshipTypes.findIndex(option => option?.id === value?.id)]}
        // value={value && relationshipTypes ? relationshipTypes.find(option => option.id === value.id) : ""}
        native={false}
        renderValue={() => value?.name || " "}
        onChange={(e) => setValue(e.target.value)}
        style={{ cursor: memoizedLocked ? 'not-allowed' : "", width: '200px' }}
      >
        <MenuItem data-cy={"Relationship-type-blank-dropdown-item"} key={"no-Relationship-type"} value=""></MenuItem>
        {relationshipTypes && [...relationshipTypes].sort((a, b) => a?.position - b?.position).map((option, index) => (
          <MenuItem data-cy={"Relationship-type-dropdown-item-" + index} key={'Relationship-option-' + option.id} value={option}>
            {option?.name || ""}
          </MenuItem>
        ))
        }
      </Select>
    </FormControl>
  )
}

export default RelationshipDropDown;
